// Shared avatar emoji set for player/user avatar pickers — used by offline
// GameSetup.jsx and the online profile screen (OnlineProfileScreen.jsx).
export const AVAILABLE_AVATARS = [
    '😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂',
    '🙂', '🙃', '😉', '😊', '😇', '🥰', '😍', '🤩',
    '😎', '🤓', '🧐', '🤠', '🥳', '🥸', '😏', '😒',
    '🤔', '🤨', '😐', '😑', '😶', '🙄', '😬', '🤥',
    '👻', '👽', '🤖', '💀', '☠️', '👹', '👺', '🤡',
    '💩', '👶', '👧', '🧒', '👦', '👨', '👩', '🧑',
    '👴', '👵', '🧓', '👨‍⚕️', '👩‍⚕️', '👨‍🎓', '👩‍🎓', '👨‍🏫',
    '🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼',
    '🐨', '🐯', '🦁', '🐮', '🐷', '🐸', '🐵', '🐔'
];
